import JetAccordionCollection from '@src/shared/components/JetAccordionCollection';
import React, { useState } from 'react';
import ManagerFAQContentKeys from '../ManagerFAQContentKeys';
import CourierFAQContentKeys from '../CourierFAQContentKeys';
import { PAGE_TYPE } from '../../..';
import JetAccordion from '@src/shared/components/JetAccordion';
import { Typography } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import i18n from '@src/i18n';
import { trackFAQClick as trackFAQClickManager } from '@src/pages/ProductOverview/tracking/page';
import { trackFAQClick as trackFAQClickCourier } from '@src/pages/CourierOverview/tracking/page';

const FAQList = ({pageType = PAGE_TYPE.MANAGER}) => {
  const [selectedFAQ, setSelectedFAQ] = useState(undefined);
  const questions =
  pageType === PAGE_TYPE.MANAGER
    ? ManagerFAQContentKeys
    : CourierFAQContentKeys;
  const { t } = useTranslation();
   return  <>
      <JetAccordionCollection
        collectionName="faq_first_column"
        sharedValue={selectedFAQ}
        onAccordionItemSelected={(itemIndex, indexNumber) => {
          setSelectedFAQ(itemIndex);
          if (indexNumber > -1) {
            
            const faqItem = questions[indexNumber * 2]
            if (pageType === PAGE_TYPE.MANAGER) {
              trackFAQClickManager(t(faqItem.questionKey,{ lng: 'en'}), indexNumber * 2)
            } else if (pageType === PAGE_TYPE.COURIER) {
              trackFAQClickCourier(t(faqItem.questionKey,{ lng: 'en'}), indexNumber * 2)
            }
          }
        }}
      >
        {questions
          .filter((_e, i) => i % 2 === 0)
          .map((FAQContent, index) => {
            return (
              <JetAccordion
                className={'faq-item'}
                newui={'true'}
                title={i18n.t(FAQContent.questionKey)}
                width={564}
                key={index}
              >
                <Typography
                  variant="body1"
                  className="body_regular"
                  align="left"
                >
                  <Trans i18nKey={FAQContent.answerKey} />
                </Typography>
              </JetAccordion>
            );
          })}
      </JetAccordionCollection>
      <JetAccordionCollection
        collectionName="faq_second_column"
        sharedValue={selectedFAQ}
        onAccordionItemSelected={(itemIndex,indexNumber) => {
          setSelectedFAQ(itemIndex);
          const calculatedIndex = (indexNumber * 2) + 1 
          if (indexNumber > -1) {
            const faqItem = questions[(calculatedIndex)]
            if (pageType === PAGE_TYPE.MANAGER) {
              trackFAQClickManager(t(faqItem.questionKey,{ lng: 'en'}),calculatedIndex)
            } else if (pageType === PAGE_TYPE.COURIER) {
              trackFAQClickCourier(t(faqItem.questionKey,{ lng: 'en'}), calculatedIndex)
            }
          }
        }}
      >
        {questions
          .filter((_e, i) => i % 2 !== 0)
          .map((FAQContent, index) => {
            return (
              <JetAccordion
                className={'faq-item'}
                newui={'true'}
                title={i18n.t(FAQContent.questionKey)}
                width={564}
                key={index}
              >
                <Typography
                  variant="body1"
                  className="body_regular"
                  align="left"
                >
                  <Trans i18nKey={FAQContent.answerKey} />
                </Typography>
              </JetAccordion>
            );
          })}
      </JetAccordionCollection>
    </>
}

export default FAQList